import { string, number, shape, arrayOf, oneOfType, bool } from 'prop-types';

export const debtsType = shape({
  status: string,
  period: oneOfType(number, string),
  external_id: string,
  document_number: string,
  document_type: string,
  issued_on: string,
  first_expiration_on: string,
  second_expiration_on: string,
  amount: number,
  balance: number,
  payable: bool,
  downloadable: bool,
  client_number: string,
  barcode: string
});

export const accountUnpaidType = shape({
  client_number: string.isRequired,
  address: string.isRequired,
  balance: number,
  debts: arrayOf(debtsType)
});

export const unpaidBillType = shape({
  client_number: string,
  external_id: string,
  amount: number
});
